






















































import PageContainer from '@/general/component/PageContainer.vue';
import Component from 'vue-class-component';
import CustomerRouter, {customerRouter} from '@/context/customer/router/CustomerRouter';
import {AxiosResponse} from 'axios';
import {customerApi} from '@/context/customer/api/CustomerApi';
import {CustomerFilter} from '@/context/customer/model/CustomerFilter';
import Vue from 'vue';
import {Api} from '@/common/api/Api';
import TextInput from '@/general/component/form/input/TextInput.vue';
import RemoteConfigurationRouter
  , {
  remoteConfigurationRouter
} from "@/context/remote_configuration/router/RemoteConfigurationRouter";
import {
  RemoteConfigurationFilter
} from "@/context/remote_configuration/model/RemoteConfigurationFilter";
import {
  RemoteConfigurationApi,
  remoteConfigurationApi
} from "@/context/remote_configuration/api/RemoteConfigurationApi";
import FormBase from "@/general/abstract/form/FormBase.vue";
import CustomerFormTemplate from "@/context/customer/component/CustomerFormTemplate.vue";
import RemoteConfigurationUploadFormTemplate
  from "@/context/remote_configuration/components/RemoteConfigurationUploadFormTemplate.vue";
import {CustomerFormModel} from "@/context/customer/model/CustomerFormModel";
import {IdResponse} from "@/common/model/IdResponse";
import {UploadFormModel} from "@/context/remote_configuration/model/UploadFormModel";
import {VModel} from "vue-property-decorator";
import DetailRow from "@/common/component/DetailRow.vue";
import {
  RemoteConfigurationUpload
} from "@/context/remote_configuration/model/RemoteConfigurationUpload";

@Component({
  components: {DetailRow, RemoteConfigurationUploadFormTemplate, FormBase, TextInput}
})
export default class RemoteConfigurationUploadListContainer extends Vue {
  loading = false;
  api: RemoteConfigurationApi = remoteConfigurationApi;
  submitting = false;
  model!: RemoteConfigurationUpload;

  async created() {
    this.loading = true;
    const test = await RemoteConfigurationApi.findUploadInformation(this.$route.params.id)
    this.model = await RemoteConfigurationApi.findUploadInformation(this.$route.params.id);
    console.log(this.model)
    this.loading = false;
  }

  async submit(): Promise<IdResponse> {
    const response = await RemoteConfigurationApi.uploadConfiguration(this.model)
    console.log(response);
    return Promise.resolve(new IdResponse(-1))
  };

  async goBack() {
  }

  public translateStatus(statusStr: string): string {
    switch (statusStr) {
      case 'NOT_PROCESSED':
        return 'Nie przetworzona'
      case 'PROBABLY_PROCESSED':
        return 'Czekanie na potwierdzenie urządzenia'
      case 'PROCESSED':
        return 'Przetworzona'
      case 'ERROR':
        return 'Błąd'
      case 'DELETED':
        return 'Usunięta'
    }
    return ''
  }


}
